export default __webpack_public_path__ + "static/media/Lato-Black.32ff56fb.woff2";